import { render, staticRenderFns } from "./RoomFile.vue?vue&type=template&id=fbad3f26&"
import script from "./RoomFile.vue?vue&type=script&lang=js&"
export * from "./RoomFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbad3f26')) {
      api.createRecord('fbad3f26', component.options)
    } else {
      api.reload('fbad3f26', component.options)
    }
    module.hot.accept("./RoomFile.vue?vue&type=template&id=fbad3f26&", function () {
      api.rerender('fbad3f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomFile/RoomFile.vue"
export default component.exports